/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BuyerAgentCommissionFlatCents
 */
export interface BuyerAgentCommissionFlatCents {
}

/**
 * Check if a given object implements the BuyerAgentCommissionFlatCents interface.
 */
export function instanceOfBuyerAgentCommissionFlatCents(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BuyerAgentCommissionFlatCentsFromJSON(json: any): BuyerAgentCommissionFlatCents {
    return BuyerAgentCommissionFlatCentsFromJSONTyped(json, false);
}

export function BuyerAgentCommissionFlatCentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BuyerAgentCommissionFlatCents {
    return json;
}

export function BuyerAgentCommissionFlatCentsToJSON(value?: BuyerAgentCommissionFlatCents | null): any {
    return value;
}

